import { render } from "./ModalRenovacao.vue?vue&type=template&id=6bb4b558&ts=true"
import script from "./ModalRenovacao.vue?vue&type=script&lang=ts"
export * from "./ModalRenovacao.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__